export default `1.2.1${process.env.NODE_ENV === "development" ? "-dev" : ""}`;
